import React from "react";
import Modal from "../modal-new";
import SvgIcon from "../SvgIcon";

class ConnectedAccountModal extends React.Component {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    const { generateLink, onClose, context } = this.props;

    const { query } = context.locals;
    const link = query && query.link;
    return (
      <Modal
        width="800px"
        onClose={onClose}
        title={"Welcome"}
        className="connected-account-modal"
      >
        <div className="body">
          <header className="mb-6">
            <p className="s1">
              Welcome to <span className="clipped">PUSH</span> by MyStrengthBook
            </p>
          </header>
          <div className="welcome connected-account">
            <p className="mb-2">
              Congrats! You have been approved for a PUSH by MyStrengthBook
              custom app.
            </p>
            <p className="mb-2">
              {" "}
              To deposit your subscription payouts we require you to have a
              stripe account. Please use the following link to set up your
              account. It will only take about 5 minutes.
            </p>
            <p className="mb-2">
              {" "}
              If you already have an existing stripe account, use the same link
              to make it a connected account with MyStrengthBook.
            </p>
            <b>
              <p className="s1 mb-2">Important</p>
              <ul className="chip-container">
                <li>
                  <SvgIcon
                    src={"/img/new-icons/chip-warning.svg"}
                    noFilterOnLight={true}
                  />
                  <span>
                    The following link can only be clicked once, so only click
                    the link when you are ready to fully complete the stripe
                    setup process
                  </span>
                </li>
                <li>
                  <SvgIcon
                    src={"/img/new-icons/chip-warning.svg"}
                    noFilterOnLight={true}
                  />
                  <span>
                    Please have your banking information, company information,
                    personal information and your cell phone ready when you
                    start the process
                  </span>
                </li>
                <li>
                  <SvgIcon
                    src={"/img/new-icons/chip-warning.svg"}
                    noFilterOnLight={true}
                  />
                  <span>
                    Once you generate the stripe link by clicking the button
                    below, you only have 5 minutes to begin the process
                  </span>
                </li>
              </ul>

              <p className="font-normal">
                Contact{" "}
                <a
                  className="text-[--information]"
                  href="mailto:info@mystrengthbook.com"
                >
                  info@mystrengthbook.com
                </a>{" "}
                or whatsapp
                <span className="text-[--information]"> 1-587-830-5036 </span>
                for assistance
              </p>
            </b>
          </div>
        </div>
        <footer className="items-center">
          {!link && (
            <button data-button-type="primary" onClick={generateLink}>
              Generate Link
            </button>
          )}
          {link && (
            <div className="link-info">
              <SvgIcon
                src="/img/new-icons/vuesax-linear-info-circle.svg"
                noFilterOnLight={true}
              />
              <span>{query.link}</span>
            </div>
          )}
          {link && (
            <a role="button" data-button-type="primary" href={link}>
              Open Link
            </a>
          )}
        </footer>
      </Modal>
    );
  }
}

export default ConnectedAccountModal;
